import React from 'react';

import { FormHelperText, FormHelperTextProps } from '_lib/components/FormHelperText/FormHelperText';
import { FieldIssueProps, getIssuesError } from '_lib/utils/validationErrorUtils';

export type SimpleErrorDisplayProps = FormHelperTextProps & FieldIssueProps;

export const SimpleErrorDisplay = (props: SimpleErrorDisplayProps) => {
  const { issues, issuePath, matchPartial, ...restFormHelperTextProps } = props;

  const error = getIssuesError({ issues, issuePath, matchPartial });

  return error ? (
    <FormHelperText {...restFormHelperTextProps} error={true}>
      {error}
    </FormHelperText>
  ) : (
    <></>
  );
};
